module.exports = __webpack_public_path__ + "static/img/OM2.75daf4d4.png";